import React, { useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
  CFormSwitch,
  CSmartTable,
} from '@coreui/react-pro'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import FixtureService from 'src/service/FixtureService'
import EditForm from './EditForm'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'
const Table = (props) => {
  const [visibleHorizontal, setVisibleHorizontal] = useState(false)
  const [selectedId, setSelectedId] = useState(0)
  const [details, setDetails] = useState([])
  const [isEditFormVisible, setIsEditFormVisible] = useState(false) // New state to control EditForm visibility

  const toggleDetails = (index) => {
    setSelectedId(index)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
      setIsEditFormVisible(true)
    }
    setDetails(newDetails)
  }

  const handleEditFormSubmit = () => {
    setIsEditFormVisible(false) // Close EditForm when submitted
  }

  const deleteFixture = (id) => {
    const data = {}
    data.id = id
    const position = details.indexOf(id)
    let newDetails = details.slice()
    newDetails.splice(position, 1)
    setDetails(newDetails)
    // setUsers((previousEmployeeData) => previousEmployeeData.data.filter((data) => data.id !== id))
    FixtureService.deleteFixture(data).then((res) => {
      if (res.status === 200) {
        props.setLoading(false)
        props.fetchData(
          props.activePage,
          props.columnFilter,
          props.columnSorter,
          props.itemsPerPage,
        )
        ToastComponent(res.message, 'success')
      }
    })
  }

  const hideEditDiv = () => {
    setVisibleHorizontal(false)
  }
  const handleChangeStatus = (itemId) => {
    const position = props.displayDetails.indexOf(itemId)
    let newDetails = props.displayDetails.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...props.displayDetails, itemId]
    }

    props.setDisplayDetails(newDetails)
    //setIsRadio(+itemId)

    const data = {}
    data.fixtureId = itemId
    FixtureService.changeDisplayStatus(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => {
    console.log('You clicked No!')
    return setShowConfirm(false)
  }

  const handleConfirm = () => {
    deleteFixture(tableId)
    return setShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    const data = {}
    data.id = id
    data.type = 'fixture'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }
  return (
    <>
      <CSmartTable
        columns={props.columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          round: (item) => <td>{item.round ?? '-'}</td>,
          status: (item) => (
            <td>
              {item.status === 0 && <CBadge color={'warning'}>Not Started</CBadge>}
              {item.status === 1 && <CBadge color={'danger'}>In-Progress</CBadge>}
              {item.status === 2 && <CBadge color={'success'}>Completed</CBadge>}
            </td>
          ),
          grade: (item) => <td>{item.grade ?? ''}</td>,
          start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
          start_time: (item) => <td> {moment(item.start_time, ['HH:mm']).format('h:mm A')} </td>,
          show_details: (item) => {
            return (
              <>
                <td className="py-2">
                  <CButton
                    color="primary"
                    variant="outline"
                    shape="square"
                    size="sm"
                    onClick={() => {
                      toggleDetails(item.id)
                    }}
                  >
                    {details.includes(item.id) ? 'Hide' : 'Manage'}
                  </CButton>
                </td>
              </>
            )
          },
          display: (item, key) => {
            return (
              <>
                <td className="py-2">
                  {' '}
                  <CFormSwitch
                    label=""
                    id={`display_id${item.id}`}
                    name={`display_name${item.id}`}
                    value={item.id}
                    // checked={isRadio === item.id}
                    checked={props.displayDetails.includes(item.id) ? false : true}
                    onChange={(e) => handleChangeStatus(item.id)}
                  />
                  {/* <input
                    type="radio"
                    id={`radio${item.id}`}
                    value={key}
                    onChange={handleChangeStatus}
                    checked={isRadio === key}
                  /> */}
                </td>
              </>
            )
          },
          details: (item) => {
            return (
              <CCollapse
                visible={details.includes(item.id) && isEditFormVisible} // Show EditForm only if details are visible and isEditFormVisible is true
              >
                <CCardBody>
                  <CButton
                    size="sm"
                    color="success"
                    className="ms-1"
                    onClick={() => setVisibleHorizontal(!visibleHorizontal)}
                    aria-expanded={visibleHorizontal}
                    aria-controls="collapseEdit"
                  >
                    Edit
                  </CButton>
                  <CButton
                    size="sm"
                    color="danger"
                    className="ms-1"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    Delete
                  </CButton>
                  <CCollapse id="collapseEdit" horizontal visible={visibleHorizontal}>
                    <CCard className="mb-4">
                      <CCardHeader>
                        <strong>Edit Fixture</strong>
                      </CCardHeader>
                      <CCardBody>
                        <EditForm
                          fixtureId={item.id}
                          selectedId={selectedId}
                          hideEditDiv={hideEditDiv}
                          toggleDetails={toggleDetails}
                          activePage={props.activePage}
                          setActivePage={props.setActivePage}
                          columnFilter={props.columnFilter}
                          setColumnFilter={props.setColumnFilter}
                          columnSorter={props.columnSorter}
                          setColumnSorter={props.setColumnSorter}
                          itemsPerPage={props.itemsPerPage}
                          setItemsPerPage={props.setItemsPerPage}
                          fetchData={props.fetchData}
                          onSubmit={handleEditFormSubmit}
                          setLoading={props.setLoading}
                          loading={props.loading}
                          gameType={props.gameType}
                        />
                      </CCardBody>
                    </CCard>
                  </CCollapse>
                </CCardBody>
              </CCollapse>
            )
          },
        }}
        items={props.users?.data}
        itemsPerPage={props.itemsPerPage}
        itemsPerPageSelect
        loading={props.loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: props.activePage,
          pages: Math.ceil(props.users?.total / props.itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => props.setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          props.setActivePage(1)
          props.setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          props.setActivePage(1)
          props.setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => props.setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </>
  )
}

export default Table
